import React from "react";
import { Input, FormGroup } from "reactstrap";

const SinglePermission = ({
  iconImg,
  mainText,
  subText,
  permission,
  onPermissionChange,
}) => {
  return (
    <div
      className="py-1 px-3 d-flex align-items-center justify-content-center gap-5"
      style={{
        backgroundColor: "white",
        borderRadius: "5px",
        boxShadow: "0px 0px 5px 0px #0000001a",
        padding: "10px",
      }}
    >
      <img src={iconImg} alt="" style={{ height: "35px", width: "35px" }} />
      <div
        className="flex-fill d-flex flex-column"
        style={{
          width: "min-content",
        }}
      >
        <span style={{ fontSize: "16px" }} className="fw-semibold p-0 m-0">
          {mainText}
        </span>
        <span
          className="p-0 m-0 mt-1 fs-5"
          style={{
            color: "#6c757d",
            fontSize: "13px",
          }}
        >
          {subText}
        </span>
      </div>
      <div>
        {permission != null && (
          <FormGroup switch>
            <Input
              style={{
                fontSize: "1rem",
              }}
              type="switch"
              checked={permission}
              onClick={(e) => {
                onPermissionChange(e);
              }}
            />
          </FormGroup>
        )}
      </div>
    </div>
  );
};

export default SinglePermission;
